import { DirtyController } from "./DirtyController";
export class CoreGraphNode {
  constructor(_scene, _name) {
    this._scene = _scene;
    this._name = _name;
    this._dirtyController = new DirtyController(this);
    this.disposed = false;
    this._graphNodeId = _scene.graph.nextId();
    _scene.graph.addNode(this);
    this._graph = _scene.graph;
  }
  dispose() {
    this._dirtyController.dispose();
    this.graphRemove();
    this.disposed = true;
  }
  name() {
    return this._name;
  }
  setName(name) {
    this._name = name;
  }
  scene() {
    return this._scene;
  }
  graphNodeId() {
    return this._graphNodeId;
  }
  get dirtyController() {
    return this._dirtyController;
  }
  setDirty(trigger) {
    trigger = trigger || this;
    this._dirtyController.setDirty(trigger);
  }
  setSuccessorsDirty(trigger) {
    this._dirtyController.setSuccessorsDirty(trigger);
  }
  removeDirtyState() {
    this._dirtyController.removeDirtyState();
  }
  isDirty() {
    return this._dirtyController.isDirty();
  }
  addPostDirtyHook(name, callback) {
    this._dirtyController.addPostDirtyHook(name, callback);
  }
  removePostDirtyHook(name) {
    this._dirtyController.removePostDirtyHook(name);
  }
  graphRemove() {
    this._graph.removeNode(this);
  }
  addGraphInput(src, check_if_graph_has_cycle = true) {
    return this._graph.connect(src, this, check_if_graph_has_cycle);
  }
  removeGraphInput(src) {
    this._graph.disconnect(src, this);
  }
  graphDisconnectPredecessors() {
    this._graph.disconnectPredecessors(this);
  }
  graphDisconnectSuccessors() {
    this._graph.disconnectSuccessors(this);
  }
  graphPredecessorIds() {
    return this._graph.predecessorIds(this._graphNodeId) || [];
  }
  graphPredecessors() {
    return this._graph.predecessors(this);
  }
  graphSuccessors() {
    return this._graph.successors(this);
  }
  graphAllPredecessors() {
    return this._graph.allPredecessors(this);
  }
  graphAllSuccessors() {
    return this._graph.allSuccessors(this);
  }
}
